export const formatAmount = (amount) => {
    if(amount == undefined){
        amount = 0;
    }
    return  "Gs. " + Intl.NumberFormat("de-DE").format(amount);
}
